export const ORGANISATIONS_DROPDOWN_LIST = 'ORGANISATION/ORGANISATIONS_DROPDOWN_LIST'
export const ORGANISATIONS_DROPDOWN_LIST_SUCCESS = 'ORGANISATION/ORGANISATIONS_DROPDOWN_LIST_SUCCESS'
export const ORGANISATIONS_DROPDOWN_LIST_FAILED = 'ORGANISATION/ORGANISATIONS_DROPDOWN_LIST_FAILED'

export const CLEAR_ORGANISATIONS_DROPDOWN_LIST = 'ORGANISATION/CLEAR_ORGANISATIONS_DROPDOWN_LIST'
